import { Link, useHistory } from "react-router-dom";
import React, { useRef, useState } from "react";
import { options } from "./non-user-contents";
import { getAllNonRegisteredUsersService } from "../utils";
import NonRegisterUsersPresentational from "./nonRegisterUserPresentational";

const NonRegisterUser = () => {
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("mobileNumber");
  const [searchByValue, setSearchByValueHandler] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [allUserList, setAllNonRegUserList] = useState([]);
  const [nonRegUsersLoading, setNonRegUsersLoading] = useState(false);
  const [searchErrorText, setSearchErrorText] = useState("");

  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");
  let request = {
    emiratesId: "",
    cardNumber: "",
    employeeId: "",
    citizenId: "",
    labourCardNumber: "",
    mobileNumber: "",
    dateOfBirth: "",
    cardSerialNumber: "",
    iban: "",
    partnerCode: "",
    personId: "",
    name: "",
    corporateId: "",
  };
  const columns = [
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          /**
           * Comented as per CS team instructions
           */
          // <Link
          //   style={{ color: "black" }}
          //   to={{
          //     pathname: "/admin/non-registered-user-profile",
          //     state: { id: states.id, rowData: states },
          //   }}
          // >
          <i style={{ fontSize: 18 }} className="fas fa-search" />
          // </Link>
        );
      },
    },
    {
      dataField: "citizenId",
      text: "CT ID ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "firstName",
      text: "Full Name",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
      formatter: (cell, row) => {
        return (
          <span>
            {row.firstName} {row.lastName}
          </span>
        );
      },
    },
    {
      dataField: "mobileNumber",
      text: "Mobile Number",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "corporateId",
      text: "Branch Id ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "emiratesId",
      text: "Emirates Id",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
    },
    {
      dataField: "cardSerialNumber",
      text: "Card Serial Number",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
    },
  ];

  const getAllNonRegUsers = () => {
    request[searchBy] = searchByValue;
    setNonRegUsersLoading(true);
    getAllNonRegisteredUsersService(request)
      .then((res) => {
        setAllNonRegUserList(res.data);
        setNonRegUsersLoading(false);
      })
      .catch((err) => {
        setNonRegUsersLoading(false);
        setAllNonRegUserList([]);
      });
  };

  const handleFIlter = () => {
    const validateMsg = validate(searchByValue);
    if (validateMsg === "") {
      getAllNonRegUsers();
      setSearchErrorText("");
    } else {
      setSearchErrorText(validateMsg);
    }
  };

  const pattern = new RegExp("^" + "00971");
  const validate = (val) => {
    if (
      (searchBy === "mobileNumber" &&
        val === "" &&
        searchBy === "mobileNumber" &&
        val.length < 9) ||
      (searchBy === "mobileNumber" && !pattern.test(val))
    ) {
      return "Enter full Mobile Number";
    } else if (searchBy === "name" && val.length < 3) {
      return "Min 3 characters required";
    } else if (searchBy === "citizenId" && val.length < 15) {
      return "Enter full Citizen Id";
    } else if (
      searchBy === "corporateId" &&
      (val.length <= 3 || val.length >= 6)
    ) {
      return "Enter full Branch Id";
    } else if (searchBy === "emiratesId" && val.length < 15) {
      return "Enter full Emirates Id";
    } else if (searchBy === "cardSerialNumber" && val.length < 10) {
      return "Enter full Card Serial Number";
    } else {
      return "";
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };

  const rowOnClick = {
    onClick: (e, row, rowIndex) => {
      /**
       * Comented as per CS team instructions
       */
      // history.push({
      //   pathname: `/admin/kycNonRegistered/${row.citizenId}`,
      //   state: { id: row.id, rowData: row },
      // });
    },
  };

  return (
    <NonRegisterUsersPresentational
      searchBy={searchBy}
      setSearchByValueHandler={setSearchByValueHandler}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={""}
      searchByValue={searchByValue}
      rowOnClick={rowOnClick}
      setModalShow={setModalShow}
      handleFIlter={handleFIlter}
      allUserList={allUserList}
      nonRegUsersLoading={nonRegUsersLoading}
      buttonRef={buttonRef}
      columns={columns}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      handleChange={handleChange}
      options={options}
      selectedOption={selectedOption}
      searchErrorText={searchErrorText}
      setSearchErrorText={setSearchErrorText}
    />
  );
};

export default NonRegisterUser;
